import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { addNewAd } from "../../../api/webContentRequets";
import ScreenTitle from "../../../components/ScreenTitle";
import { SimpleDialog } from "../../../components/dialogs";
import commonStyle from "../../../style/commonStyle.module.css";
import useDocumentTitle from "../../../useDocumentTitle";
import QuestionsForm from "./AdForm";


export default function NewAd() {
  useDocumentTitle("Add New Ad");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.userLogin);
  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.data.token}`,
     
    },
  };

const [saveStatus, setSaveStatus] = useState({
  loading: false,
  success: false,
  error: ""
})


  const initialvalues = {
    type: "",
    image: "",
    uri: "",
  };

  //  dialog
  const handleSave = async (values) => {

    try {
      setDialog(true);
      setSaveStatus({...saveStatus, loading: true})
      const responseData = await addNewAd(values, config, dispatch);
      if (responseData.data.success) {
        setSaveStatus({...saveStatus, loading: false, success: true})
       
      } else {
        throw responseData.data.message;
      }
    } catch (error) {
      setSaveStatus({...saveStatus, loading: false, error: error})
    }
  };
  const [dialog, setDialog] = useState(false);

  const closeDialogWithSuccess = () => {
    setDialog(false);
    navigate("/web-content/ads", { replace: true, from: location });
  };

  return (
    <div className={commonStyle.pageContainer}>
      <SimpleDialog
        title="Add New Ad"
        successMessage="New ad added successfully."
        isDialogOpen={dialog}
        closeDialog={() => setDialog(false)}
        loading={saveStatus.loading}
        loadingMessage="Processing request..."
        success={saveStatus.success}
        error={saveStatus.error}
        confirmAction={closeDialogWithSuccess}
      />

      <div className="w-full p-8">
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink underline="hover" color="inherit" to="/">
            Home
          </NavLink>
          <NavLink underline="hover" color="inherit" to="/web-content/ads">
            Ads
          </NavLink>
          <NavLink
            underline="hover"
            color="text.primary"
            to={`/web-content/ads/new`}
            aria-current="page"
          >
            New Ad
          </NavLink>
        </Breadcrumbs>
        <ScreenTitle title="Add New Ad" />

        <QuestionsForm
          type="new"
          onSave={handleSave}
          initialValues={initialvalues}
        />
      </div>
    </div>
  );
}
